module.exports = __webpack_public_path__ + "static/media/profile-lance-squires.06cb3ada.jpg";